module.exports = __webpack_public_path__ + "static/media/no-result.586ee727.png";